import {connect} from 'react-redux';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import lifecycle from 'recompose/lifecycle';
import {getStatus} from 'redux-resource';
import {createCollection, dropStatus} from '../../../../redux/actions/collections';
import AdminCollectionDetails from '../details/index';
import withNavigateToList from '../with-navigate-to-list';

function mapStateToProps(state) {
	const status = getStatus(state, 'collections.requests.create.status');

	return {
		status
	};
}

function mapDispatchToProps(dispatch, props) {
	return {
		cleanUp() {
			dispatch(dropStatus());
		},
		doSubmit(values) {
			dispatch(createCollection(values))
				.then(props.navigateToList);
		},
		handleCancel() {
			props.navigateToList();
		}
	};
}

const enhance = compose(
	withNavigateToList,
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentWillUnmount() {
			this.props.cleanUp();
		}
	}),
	mapProps(props => {
		const {
			history, navigateToList, cleanUp, ...rest
		} = props;

		return 	{
			...rest,
			submitLabel: 'Create',
			formTitle: 'A new collection'
		};
	})
);

export default enhance(AdminCollectionDetails);



// WEBPACK FOOTER //
// ./src/client/components/admin/collections/create/index.js